var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBrowWax(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "25px",
    height: "14px",
    viewBox: "0 0 25 14",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "icon_Shipping") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Mobile-Flow",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "MVP/20",
    transform: "translate(-175.000000, -448.000000)",
    fill: "#000000",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Selectable-Card-Copy-4",
    transform: "translate(138.000000, 419.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-5",
    transform: "translate(9.500000, 24.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "icon_Shipping",
    transform: "translate(28.000000, 5.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M19.9739699,8.62456216 L24,11.2214384 L19.9739699,13.8183145 L2.43815755,13.8183145 C1.07760319,13.8183145 0,12.6429424 0,11.2214384 C0,9.87244001 0.972908849,8.73497306 2.28001015,8.6303486 L2.28001015,8.6303486 L2.43815755,8.62456216 L19.9739699,8.62456216 Z M3.214,10.001 L2.46574583,10.0015437 L2.36284556,10.0051108 C1.82251246,10.0485919 1.37753424,10.5688339 1.37753424,11.2214384 C1.37753424,11.9075737 1.86638802,12.4407803 2.43815755,12.4407803 L2.43815755,12.4407803 L3.214,12.44 L3.214,10.001 Z M16.989,10.001 L4.591,10.001 L4.591,12.44 L16.989,12.44 L16.989,10.001 Z M19.5683331,10.0018169 L18.367,10.001 L18.367,12.44 L19.5683331,12.4400526 L21.4583101,11.2213939 L19.5683331,10.0018169 Z M2.87485427,0 L2.87485427,4.5200065 L12.671954,4.5200065 L12.7698026,4.52174206 L12.9974899,4.53574194 C13.0385558,4.53928478 13.0811784,4.54343223 13.1253544,4.5481841 L13.4090212,4.58394671 C13.4593963,4.59111544 13.5113177,4.59888817 13.564782,4.60726471 L13.9040544,4.66476796 L14.2801892,4.73675269 L14.913145,4.87186108 L15.3807085,4.98000655 L16.1500279,5.16931003 L16.707981,5.31355487 L17.6121051,5.55696137 L18.5963638,5.8327855 L19.6601959,6.14099412 L21.6178917,6.71652274 L20.4094563,5.07229349 C17.9445318,1.71845168 15.3685142,0 12.671954,0 L2.87485427,0 Z M4.25198903,3.14169643 L4.25198903,1.37753424 L12.671954,1.37753424 L12.8905258,1.38245675 C14.4940532,1.45467617 16.1122089,2.32205358 17.7412656,4.01734568 L17.9272306,4.21525478 L17.2690309,4.03676569 L16.3065738,3.78801568 L15.7191193,3.64469583 L15.1747858,3.51937233 L14.6733798,3.41203278 L14.214708,3.32266479 C14.1418131,3.30926707 14.0706907,3.29661765 14.0013369,3.28471627 L13.6064033,3.22228241 L13.2537201,3.17778915 C13.0879088,3.16002561 12.9378688,3.14898514 12.8034913,3.14466079 L12.6834892,3.14256885 L4.25198903,3.14169643 Z",
    id: "Icon-Color"
  }))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBrowWax);
export default __webpack_public_path__ + "static/media/brow-wax.a747814aaff041ac8ff13b6a4a5fe3c7.svg";
export { ForwardRef as ReactComponent };